(function () {
  if (window.customBundlePickerLoaded) return;
  window.customBundlePickerLoaded = true;

  // Lock/unlock gift tiles straight away; product-info.js re-renders them from the server shortly after.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('.custom-bundle__input')) return;

    const position = Number(input.dataset.position);
    input
      .closest('.custom-bundle')
      .querySelectorAll('[data-unlock]')
      .forEach((gift) => gift.classList.toggle('is-locked', position < Number(gift.dataset.unlock)));
  });

  // The default bundle is pre-checked inline before paint; tell the theme about it so the
  // add-to-cart form, price and URL switch to that variant.
  const syncDefault = () => {
    const input = window.customBundlePendingDefault;
    window.customBundlePendingDefault = null;
    if (input && input.isConnected && input.checked) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDefault);
  } else {
    syncDefault();
  }
})();
